import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export var LogoProvider = /*#__PURE__*/function () {
  function LogoProvider(source) {
    this._source = source;
  }

  var _proto = LogoProvider.prototype;

  _proto.getSource = function getSource() {
    return this._source;
  };

  _proto.getSVG = /*#__PURE__*/function () {
    var _getSVG = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getSVG() {
      return _getSVG.apply(this, arguments);
    }

    return getSVG;
  }();

  _proto.hasDefault = function hasDefault() {
    return false;
  };

  _proto.searchIcons = /*#__PURE__*/function () {
    var _searchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              throw new Error("'searchIcons' Not implemented Exception - source: " + this._source);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function searchIcons() {
      return _searchIcons.apply(this, arguments);
    }

    return searchIcons;
  }();

  _proto.getIconById = /*#__PURE__*/function () {
    var _getIconById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              throw new Error("getIconById - Not implemented Exception - source: " + this._source + " | id: " + id);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getIconById(_x) {
      return _getIconById.apply(this, arguments);
    }

    return getIconById;
  }();

  _proto.searchIconsWithSource = /*#__PURE__*/function () {
    var _searchIconsWithSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(arrSearchTerms, options, skipOverride) {
      var arrIconsResult;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (skipOverride === void 0) {
                skipOverride = true;
              }

              _context4.next = 3;
              return this.searchIcons(arrSearchTerms, options);

            case 3:
              arrIconsResult = _context4.sent;

              if (!arrIconsResult) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", this._fillIconListWithSource(this.getSource(), skipOverride)(arrIconsResult));

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function searchIconsWithSource(_x2, _x3, _x4) {
      return _searchIconsWithSource.apply(this, arguments);
    }

    return searchIconsWithSource;
  }();

  _proto._fillIconListWithSource = function _fillIconListWithSource(fixedSource, skipOverride) {
    return function (arrIcons) {
      return arrIcons.map(function (result) {
        var id = result.id,
            iconUrl = result.iconUrl,
            source = result.source,
            _result$colors = result.colors,
            colors = _result$colors === void 0 ? [] : _result$colors;
        var iconSource = fixedSource;

        if (skipOverride) {
          iconSource = source || fixedSource;
        }

        return {
          id: id,
          iconUrl: iconUrl,
          source: iconSource,
          colors: colors
        };
      });
    };
  };

  return LogoProvider;
}();